export default "__VITE_ASSET__7f70157a__"